import { Canvas } from '@react-three/fiber'
import Globe from './globe';
export default function PersonalInfo() {
    return (
        <div className='personal-info'>
            <div className='content'>
                <div className="personal-details">
                    <p className="detail">Code. Innovate. Conquer.</p>
                    <p className="detail" style={{textAlign:"right"}}>Join Me!</p>
                </div>
                <h1 className='name'>BYTE</h1>
                <div className="canvas-container">
                    <Canvas>
                        <ambientLight intensity={0.01} />
                        <directionalLight color="white" position={[0, 0, 1]} />
                        <Globe/>
                    </Canvas>
                </div>
                <div className="star-bg">
                    <svg className='star'  viewBox="0 0 200 200" fill="#2EC4B6" xmlns="http://www.w3.org/2000/svg"> 
                        <path d="M100.106 0L115 54.1591L158.884 19.0983L139.1 71.6687L195.211 69.0983L148.306 100L195.211 130.902L139.1 128.331L158.884 180.902L115 145.841L100.106 200L85.211 145.841L41.3271 180.902L61.111 128.331L5 130.902L51.9057 100L5 69.0983L61.111 71.6687L41.3271 19.0983L85.211 54.1591L100.106 0Z" fill="#2EC4B6"/>
                    </svg>
                </div>
            </div>
            <script src='script.js'></script>
        </div>
    );
}